import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdMatchSignalsOptions, getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsOptions } from '@onefootprint/fetch-dashboard';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import ErrorComponent from './components/error';
import Loading from './components/loading';
import { ValidationTimelineItemBody, ValidationTimelineItemHeader, ValidationTimelineItemIcon } from './components/validation-timeline-item';
import transformResponse from './utils/transform-response';
type OnboardingFieldValidationsProps = {
  entityId: string;
  onboardingId?: string;
};
const OnboardingFieldValidations = t0 => {
  const $ = _c(24);
  const {
    entityId,
    onboardingId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.onboardingDecisionEvent.notVerifiedDetails.drawer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let options;
  if (onboardingId) {
    let t2;
    if ($[1] !== entityId || $[2] !== onboardingId) {
      t2 = getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsOptions({
        path: {
          fpId: entityId,
          onboardingId
        }
      });
      $[1] = entityId;
      $[2] = onboardingId;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    options = t2;
  } else {
    let t2;
    if ($[4] !== entityId) {
      t2 = getEntitiesByFpIdMatchSignalsOptions({
        path: {
          fpId: entityId
        }
      });
      $[4] = entityId;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    options = t2;
  }
  let t2;
  if ($[6] !== options) {
    t2 = {
      ...options,
      select: transformResponse
    };
    $[6] = options;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    data,
    isError,
    error,
    isPending
  } = useQuery(t2);
  let t3;
  if ($[8] !== data || $[9] !== t) {
    t3 = () => {
      if (data && data.length > 0) {
        return data.map(_temp);
      }
      if (data && data.length === 0) {
        return <p className="text-body-2">{t(_temp2)}</p>;
      }
      return null;
    };
    $[8] = data;
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const getContent = t3;
  let t4;
  if ($[11] !== error || $[12] !== isError) {
    t4 = isError && <ErrorComponent error={error} />;
    $[11] = error;
    $[12] = isError;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== isPending) {
    t5 = isPending && <Loading />;
    $[14] = isPending;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== getContent || $[17] !== isError || $[18] !== isPending) {
    t6 = !isError && !isPending && getContent();
    $[16] = getContent;
    $[17] = isError;
    $[18] = isPending;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <div>{t4}{t5}{t6}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export type { OnboardingFieldValidationsProps };
export default OnboardingFieldValidations;
function _temp(validationEntry) {
  const {
    attribute,
    matchLevel,
    signals
  } = validationEntry;
  return <div key={attribute} className="flex flex-col mb-3 last:mb-0 border border-tertiary rounded"><div className="flex flex-row items-center gap-2 px-3 py-2 border-b border-tertiary"><ValidationTimelineItemIcon attribute={attribute} /><ValidationTimelineItemHeader attribute={attribute} matchLevel={matchLevel} /></div><div className="px-3 py-2 flex flex-col gap-2"><ValidationTimelineItemBody signals={signals} /></div></div>;
}
function _temp2($) {
  return $.noData;
}